import { render, staticRenderFns } from "./contenido.vue?vue&type=template&id=29ce1a12&scoped=true&"
import script from "./contenido.vue?vue&type=script&lang=ts&"
export * from "./contenido.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ce1a12",
  null
  
)

export default component.exports